export enum EnumPriceComponentReference {
  Contrato = 1,
  Flexibilidad,
  Peaje,
  Oferta,
  Lead,
  PresionTension,
  RegionImpuestos,
  General
}
